export var CheckoutSdkFrameParam;
(function (CheckoutSdkFrameParam) {
    CheckoutSdkFrameParam["Referrer"] = "referrer";
    CheckoutSdkFrameParam["Version"] = "version";
    CheckoutSdkFrameParam["SdkType"] = "sdkType";
})(CheckoutSdkFrameParam || (CheckoutSdkFrameParam = {}));
//# sourceMappingURL=checkout-sdk-frame-param.js.map